import { zodResolver } from '@hookform/resolvers/zod';
import { Anschrift, Kind, Personendaten, Wohnsituation } from 'cpool-schemas';
import { isValidPostalCode } from 'cpool-utils';
import { z } from 'zod';

const AnschriftForm = Anschrift.superRefine(({ land, plz }, ctx) => {
    if (!isValidPostalCode(plz, land)) ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['plz'] });
});

const WohnsituationForm = Wohnsituation.omit({ wohnflaeche: true }).extend({
    anschrift: AnschriftForm.optional(),
    vorherigeAnschrift: AnschriftForm.optional(),
});

export const schemaLivingSituationForm = z.object({
    antragsteller1: z.object({
        familienstand: Personendaten.shape.familienstand.nullish(),
        wohnsituation: WohnsituationForm,
    }),
    antragsteller2: z
        .object({
            familienstand: Personendaten.shape.familienstand.nullish(),
            wohnsituation: WohnsituationForm.nullish(),
        })
        .optional(),
    kinder: z.array(Kind).optional().default([]),
});

export type SchemaLivingSituationForm = z.input<typeof schemaLivingSituationForm>;
export const resolverLivingSituationForm = zodResolver(schemaLivingSituationForm);
